<template>
    <div>
        <v-card class="">
            <person-phone-numbers-table :person-id="personId" />
        </v-card>
    </div>
</template>

<script>
    import PersonPhoneNumbersTable from './PersonPhoneNumbersTable';

    export default {

        name: "BankDetail",

        components: {
            PersonPhoneNumbersTable
        },

        props: {
            personId: {
                type: Number,
                required: true,
            },
        },
    }
</script>

<style scoped>
</style>
